import { apiFetch } from '../utils/api';
import { extractMapUrlFromText } from '../utils/extractMapUrl';
import { parseCoordinate, parseCoordinateString } from '../utils/coordParse';
import { pickFillCoordinatesFromMapUrlResult } from '../utils/coordinateTool';

/**
 * 智能识别 / 粘贴解析 / 地图链接解析
 */
export default function useCoordinateToolParse({
  inputLat,
  inputLng,
  setInputLat,
  setInputLng,
  mapUrl,
  setMapUrl,
  setMapUrlResult,
  setLoading
}) {
  const handleCoordinateParse = () => {
    const inputLatValue = inputLat;
    const inputLngValue = inputLng;

    if (!inputLatValue && !inputLngValue) {
      alert('请先输入经纬度坐标。');
      return;
    }

    let lat, lng;

    const combinedCoords = parseCoordinateString(inputLatValue) || parseCoordinateString(inputLngValue);

    if (combinedCoords) {
      lat = combinedCoords.lat;
      lng = combinedCoords.lng;
    } else if (inputLatValue && inputLngValue) {
      lat = parseCoordinate(inputLatValue);
      lng = parseCoordinate(inputLngValue);
    } else {
      alert('请输入完整的经纬度坐标。');
      return;
    }

    if (isNaN(lat) || isNaN(lng)) {
      alert('坐标格式不正确，请检查输入。');
      return;
    }

    if (lat < -90 || lat > 90) {
      alert('纬度范围应在 -90 到 90 之间。');
      return;
    }

    if (lng < -180 || lng > 180) {
      alert('经度范围应在 -180 到 180 之间。');
      return;
    }

    setInputLat(lat.toFixed(6));
    setInputLng(lng.toFixed(6));

    alert(`已智能识别并填充经纬度：\n纬度: ${lat.toFixed(6)}\n经度: ${lng.toFixed(6)}`);
  };

  const handleCoordinatePaste = (e, field) => {
    const pastedText = e.clipboardData.getData('text');

    if (pastedText.includes(',') && /[\d.-]/.test(pastedText)) {
      e.preventDefault();

      const coords = parseCoordinateString(pastedText);
      if (coords) {
        setInputLat(coords.lat.toFixed(6));
        setInputLng(coords.lng.toFixed(6));

        setTimeout(() => {
          alert(`已自动识别粘贴的坐标：\n纬度: ${coords.lat.toFixed(6)}\n经度: ${coords.lng.toFixed(6)}`);
        }, 100);
      }
    }
  };

  const handleMapUrlParse = async () => {
    if (!mapUrl.trim()) {
      alert('请输入地图链接，或粘贴包含链接的地址文本');
      return;
    }

    const extractedUrl = extractMapUrlFromText(mapUrl);
    if (!extractedUrl) {
      alert('未从内容中识别到地图链接，请确认包含 http(s):// 链接');
      return;
    }
    if (extractedUrl !== mapUrl.trim()) {
      setMapUrl(extractedUrl);
    }

    setLoading(true);
    setMapUrlResult(null);

    try {
      const res = await apiFetch('/api/parse-map-url', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ url: extractedUrl })
      });
      const data = await res.json();
      if (data.success) {
        if (data.extractedUrl) setMapUrl(data.extractedUrl);
        setMapUrlResult(data);

        const coordinates = pickFillCoordinatesFromMapUrlResult(data);
        if (coordinates) {
          setInputLat(coordinates.lat.toString());
          setInputLng(coordinates.lng.toString());
        }
      } else {
        setMapUrlResult({ error: data.error || '解析失败' });
      }
    } catch (e) {
      setMapUrlResult({ error: '解析失败' });
    } finally {
      setLoading(false);
    }
  };

  return {
    handleCoordinateParse,
    handleCoordinatePaste,
    handleMapUrlParse
  };
}
